import {put, select, take, fork} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as caseLogActionTypes from '../caseLogActionTypes';
import config from '../../config';

/**
 * Filter case logs
 */
const filterCaseLogs = function* filterCaseLogs({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const ecsHistoryManagementService = serviceManager.loadService('ecsHistoryManagementService');
    const {searchQueryParams, serviceCaseId} = payload;

    if (!searchQueryParams.get('channel')) searchQueryParams.append('channel', config.CASE_LOG_CHANNEL);

    yield put({
        type: caseLogActionTypes.SET_CASE_LOG_FILTER_RESULTS_PERSISTENCE_STATE,
        payload: {caseLogFilterResultsPersistenceState: persistenceStates.PENDING},
    });

    yield put({
        type: caseLogActionTypes.STORE_CASE_LOGS,
        payload: {caseLogFilterResults: [], caseLogFilterResultsCount: 0, pageNumber: searchQueryParams.get('page')},
    });

    yield fork(fetchRequest,
        caseLogActionTypes.FILTER_CASE_LOGS_REQUEST,
        ecsHistoryManagementService.filterCaseLogs, {
            serviceCaseId,
            searchQueryParams,
        });

    const filterCaseLogsResponseAction = yield take([
        caseLogActionTypes.FILTER_CASE_LOGS_REQUEST_SUCCEEDED,
        caseLogActionTypes.FILTER_CASE_LOGS_REQUEST_FAILED,
    ]);

    yield put({
        type: caseLogActionTypes.SET_CASE_LOG_FILTER_RESULTS_PERSISTENCE_STATE,
        payload: {caseLogFilterResultsPersistenceState: persistenceStates.READY},
    });

    if (!filterCaseLogsResponseAction.error) {
        const {response} = filterCaseLogsResponseAction.payload;
        const {
            caseLogFilterResults,
            totalCount: caseLogFilterResultsCount,
            pageNumber,
        } = response;

        yield put({
            type: caseLogActionTypes.STORE_CASE_LOGS,
            payload: {caseLogFilterResults, caseLogFilterResultsCount, pageNumber},
        });
        return;
    }

    yield put({
        type: caseLogActionTypes.SET_CASE_LOG_FILTER_RESULTS_PERSISTENCE_STATE,
        payload: {caseLogFilterResultsPersistenceState: persistenceStates.FAILED},
    });
};

export default filterCaseLogs;
